import { clientePedido } from '../../apiClient/index'

const moduloPresupuestos = {
  namespaced: true,
  state: {
    filtrosPresupuesto: {},
    plazosPago: undefined
  },
  actions: {
    getPresupuestos(context, payload)
    {
      return new Promise((resolve) => {
        clientePedido.get('/api/Presupuesto/Find', { params: payload })
        .then(response => resolve(response.data))
      })
    },

    setFiltrosPresupuesto(context, payload)
    {
      context.commit('setFiltrosPresupuesto', payload)
    },

    iniciarPresupuesto(context, payload)
    {
      return new Promise((resolve) => {
        clientePedido.post(`/api/Presupuesto/Init?idUsuario=${payload.idUsuario}`)
        .then(response => resolve(response.data))
      })
    },

    confirmarPresupuesto(context, payload)
    {
      return new Promise((resolve)=> {
        clientePedido.post(`/api/Presupuesto/ConfirmarPresupuesto?idPresupuesto=${payload.id}`)
        .then(response => resolve(response.data))
      })
    },
    volverAIngreso(context, payload)
    {
      return new Promise((resolve)=> {
        clientePedido.post(`/api/Presupuesto/VolverAIngreso?idPresupuesto=${payload.id}`)
        .then(response => resolve(response.data))
      })
    },

    getPresupuesto(context, payload) {
      return new Promise((resolve)=> {
        clientePedido.get(`/api/Presupuesto/Get?id=${payload.id}&idUsuario=${payload.idUsuario}`)
        .then(response => resolve(response.data))
      })
    },

    getCabeceraPresupuesto(context, payload)
    {
      return new Promise((resolve) =>
      {
        clientePedido.get(`/api/Presupuesto/GetCabecera?id=${payload.id}&idUsuario=${payload.idUsuario}`)
        .then(response => resolve(response.data))
      })
    },

    anularPresupuesto(context, payload) {
      return new Promise(resolve =>{
        clientePedido.post(`/api/Presupuesto/AnularPresupuesto?id=${payload.id}`)
        .then(response => {
          var result = response.data
          resolve(result.CodigoResultado)
        })
      })
    },

    savePresupuesto(context, payload) {
      return new Promise((resolve, reject) => {
        clientePedido.post('/api/Presupuesto/Save', payload)
        .then(response => { resolve(response.data) })
        .catch(error => { reject(error) })
      })
    },

    uploadArchivoDetalles(context, payload) {

      // armo el payload
      let formData = new FormData()
      formData.append('archivo', payload.file)

      // subo el archivo
      return new Promise((resolve, reject) => {
        clientePedido.post(`/api/Presupuesto/UploadArchivoDetalles?id=${payload.id}`, formData)
        .then(
          response => { resolve(response.data) },
          error => { reject(error) }
        )
      })
    },

    importarDetallesPresupuesto(context, payload)
    {
      return new Promise((resolve) => {
        clientePedido.post(`/api/Presupuesto/ImportarDetallesPresupuesto?id=${payload.id}&idUsuario=${payload.idUsuario}`)
        .then(response => resolve(response.data))
      })
    },

    descargarPresupuesto(context, payload)
    {
      return new Promise((resolve) => {
        clientePedido.get('/api/Presupuesto/Descargar', {params: payload})
        .then(response => resolve(response.data))
      })
    },
/*
    getPlazosPago(context)
    {
      return new Promise((resolve) =>
      {
        // verifico si los plazos de pago fueron inicializados
        if(context.state.plazosPago !== undefined)
        {
          resolve(context.state.plazosPago)
        }

        else
        {
            //clientePedido.get('api/Pedido/GetPlazosPago')
            clientePedido.get('')
          .then((response) =>
          {
            let data = response.data

            if(data.CodigoResultado === 0)
            {
              let plazosPago = JSON.parse(data.Datos)
              context.commit('setPlazosPago', plazosPago)
              resolve(context.state.plazosPago)
            }
          })
        }
      })
    }
    */
  },

  mutations:
  {
    setFiltrosPresupuesto(state, payload)
    {
      state.filtrosPresupuesto = payload
    },
    /*
    setPlazosPago(state, payload)
    {
      state.plazosPago = payload
    }
    */
  }
}
export default moduloPresupuestos